var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "checkbox-list-item" }, [
      _c(
        "div",
        {
          staticClass: "checkbox checkbox-primary checkbox-list-item__checkbox",
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.option.opted_in,
                expression: "option.opted_in",
              },
            ],
            staticClass: "checkbox-list-item__checkbox",
            attrs: {
              type: "checkbox",
              name: "opportunities[]",
              id: `checkbox-opportunity-${_vm.option.id}`,
            },
            domProps: {
              value: _vm.option.id,
              checked: Array.isArray(_vm.option.opted_in)
                ? _vm._i(_vm.option.opted_in, _vm.option.id) > -1
                : _vm.option.opted_in,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.option.opted_in,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = _vm.option.id,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.option, "opted_in", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.option,
                        "opted_in",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.option, "opted_in", $$c)
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { attrs: { for: `checkbox-opportunity-${_vm.option.id}` } },
            [_vm._v("\n        " + _vm._s(_vm.option.label) + "\n      ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "money" }, [
        _c("span", { staticClass: "money__symbol" }, [
          _vm._v(_vm._s(_vm.moneySymbol)),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.option.budget,
              expression: "option.budget",
            },
          ],
          staticClass: "money__input",
          attrs: {
            disabled: !_vm.option.opted_in,
            type: "number",
            min: "0",
            step: "10",
          },
          domProps: { value: _vm.option.budget },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.option, "budget", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    !_vm.validation.budget.required || !_vm.validation.budget.minValue
      ? _c("div", { staticClass: "help-block" }, [
          _vm._v("You must set a budget\n  "),
        ])
      : _vm.budgetHint
      ? _c("div", [_vm._v(_vm._s(_vm.budgetHint))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }